import * as jsxRuntime from "/datadisk/jenkinsdata/workspace/EL-INTRANET/QUAL/Deployments/FE-QUAL/app/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment